import { httpService } from '@/services/HttpService';

class PrivateNetworkService {
  getPrivateNetworks(workspaceId: number, regionId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/private_networks`);
  }
  getDedicatedPrivateNetworks(workspaceId: number, regionId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/dedicated_private_networks`);
  }
  getPrivateNetwork(
    workspaceId: number,
    regionId: number,
    privateNetworkId: number,
    privateNetworkType: string
  ): Promise<any> {
    if (privateNetworkType === 'virtual') {
      return httpService.get(
        `workspaces/${workspaceId}/regions/${regionId}/virtual_private_networks/${privateNetworkId}`
      );
    } else {
      return httpService.get(
        `workspaces/${workspaceId}/regions/${regionId}/dedicated_private_networks/${privateNetworkId}`
      );
    }
  }
  editPrivateNetworkName(
    workspaceId: number,
    regionId: number,
    privateNetworkId: number,
    privateNetworkType: string,
    name: any
  ): Promise<any> {
    if (privateNetworkType === 'virtual') {
      return httpService.put(
        `workspaces/${workspaceId}/regions/${regionId}/virtual_private_networks/${privateNetworkId}/name`,
        name
      );
    } else {
      return httpService.put(
        `workspaces/${workspaceId}/regions/${regionId}/dedicated_private_networks/${privateNetworkId}/name`,
        name
      );
    }
  }
  updateOutputAddress(
    workspaceId: number,
    regionId: number,
    privateNetworkId: number,
    privateNetworkType: string,
    address: any
  ): Promise<any> {
    if (privateNetworkType === 'Virtual') {
      return httpService.put(
        `workspaces/${workspaceId}/regions/${regionId}/virtual_private_networks/${privateNetworkId}`,
        address
      );
    } else {
      return httpService.put(
        `workspaces/${workspaceId}/regions/${regionId}/dedicated_private_networks/${privateNetworkId}`,
        address
      );
    }
  }
  createPrivateNetwork(workspaceId: number, regionId: number, networkData: any): Promise<any> {
    if (networkData.type === 'virtual') {
      return httpService.post(`workspaces/${workspaceId}/regions/${regionId}/virtual_private_networks`, networkData);
    } else {
      return httpService.post(`workspaces/${workspaceId}/regions/${regionId}/dedicated_private_networks`, networkData);
    }
  }
  removePrivateNetwork(workspaceId: number, regionId: number, privateNetworkId: number, type: string): Promise<any> {
    if (type === 'virtual') {
      return httpService.delete(
        `workspaces/${workspaceId}/regions/${regionId}/virtual_private_networks/${privateNetworkId}`,
        ''
      );
    } else {
      return httpService.delete(
        `workspaces/${workspaceId}/regions/${regionId}/dedicated_private_networks/${privateNetworkId}`,
        ''
      );
    }
  }
}

export const privateNetworkService = new PrivateNetworkService();
